"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.atLeastOne = void 0;
const validation_1 = require("../validation/validation");
/**
 * @summary Creates a `Validation` for a list of validation. At least one validation must succeed.
 *
 * Creates a `Validation` for a list of validations. At least one validation must succeed. If no validations
 * are given, creates a validation that will always succeed.
 *
 * @param {Validation[]} rules
 * @param {string | undefined} message
 * @returns {Validation}
 *
 * @see Validation
 */
function atLeastOne(rules, message) {
    return (0, validation_1.validation)(message ?? `At least one of these conditions must apply: ${rules.map((rule) => rule.message).join(',')}`, (value) => rules.length === 0 || rules.some((rule) => rule.validate(value)));
}
exports.atLeastOne = atLeastOne;
